export default __webpack_public_path__ + "static/media/panTech4.be90b800.png";